var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"file-input"},[_c('input',{ref:"file-input",staticStyle:{"display":"none"},attrs:{"type":"file"},on:{"change":_vm.importExpenses}}),_c('button',{on:{"click":_vm.openFileInput}},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }